@if (!isLoggedIn()) {
    <ng-container [ngTemplateOutlet]="loginCard"></ng-container>
} @else {
    <ng-container [ngTemplateOutlet]="scopeCard"></ng-container>
}

<ng-template #loginCard>
    <mat-card class="riege-card riege-card--welcome">
        @defer {
            <div class="row">
                <div class="column is-6">
                    <div class="welcome-icon">
                        <mat-icon class="riege-icon md-96 scope-heart" svgIcon="scope-heart" aria-hidden="true">
                        </mat-icon>
                    </div>
                </div>
                <div class="column is-6">
                    <mat-card-content>
                        <mat-card-title>{{ greeting }}</mat-card-title>
                        <mat-card-subtitle>
                            <span i18n="@@welcome-card-subtitle">Welcome back</span>
                        </mat-card-subtitle>
                        <p class="mat-card__infotext">
                            <span i18n="@@welcome-card-today">Today is</span> {{ today | date: 'fullDate' }}
                        </p>
                    </mat-card-content>
                    <mat-card-actions>
                        <button
                            class="riege-button"
                            mat-flat-button
                            [disabled]="loginDisabled()"
                            debounceClick
                            (doClick)="login()"
                            [debounceTime]="700"
                            i18n="@@button-label-login-scope-card"
                            >Log in</button
                        >
                    </mat-card-actions>
                </div>
            </div>
        }
    </mat-card>
</ng-template>

<ng-template #scopeCard>
    <mat-card class="riege-card riege-card--welcome is-logged-in">
        @defer {
            <div class="row">
                <div class="column is-6">
                    <div class="welcome-icon">
                        <mat-icon
                            class="riege-icon md-96 {{ avatarIcon() }}"
                            svgIcon="{{ avatarIcon() }}"
                            aria-hidden="true">
                        </mat-icon>
                    </div>
                </div>
                <div class="column is-6">
                    <mat-card-content>
                        <mat-card-title>{{ greeting }}</mat-card-title>
                        <mat-card-subtitle>
                            <span class="profile__user-name">{{ currentUser().name || '&nbsp;' }}</span>
                        </mat-card-subtitle>
                        <p class="mat-card__infotext">
                            <span i18n="@@welcome-card-today">Today is</span> {{ today | date: 'fullDate' }}
                        </p>
                        @if (isMobile()) {
                            <strong i18n="@@launch-card-mobile-message"
                                >Please use the desktop version to launch Scope.</strong
                            >
                        }
                    </mat-card-content>
                    <mat-card-actions>
                        @if (servers()!.length > 1) {
                            <mat-form-field>
                                <mat-label>Server</mat-label>
                                <mat-select
                                    [value]="selectedServer()"
                                    (valueChange)="authService.selectedServer.set($event)">
                                    @for (server of servers()!; track $index) {
                                        <mat-option [value]="server">{{ server.scopeDomain }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }
                        <button
                            class="riege-button riege-button--inversed"
                            mat-flat-button
                            [disabled]="!selectedServer() || isMobile()"
                            (click)="launchScope()"
                            i18n="@@button-label-launch-scope"
                            >Launch Scope</button
                        >
                    </mat-card-actions>
                </div>
            </div>
        }
    </mat-card>
</ng-template>
